import { Box, Button, CircularProgress, Typography, LinearProgress,Switch, FormControlLabel
  , Tooltip, IconButton
 } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAxios from "src/components/withAxios";
import { ICoach, ISport, ISurvey, ISurveyResponse } from "src/services";
import { withSchoolContext } from "../../DirectorPage";
import SendEvalModal from "../SendEvalModal";
import EvaluationPrinter, {
  PrintEvaluationFunc,
} from "../evaluation/EvaluationPrinter";
import EditCoachModal from "./components/edit-coach-modal/EditCoachModal";
import VarsityCoachModal from "./components/edit-coach-modal/addVarsitycochaMoadal"; 
import EmbedCoachTable from "./components/embed-coach-table/EmbedCoachTable";
import { SeasonTabs } from "./components/season-tabs/SeasonTabs";
import SportTable from "./components/sport-table/SportTable";
import GenerateReportModal from "./reportGeneratemodal";
import {
  CREATE_COACH_BUTTON_TEXT,
  DASHBOARD_SUBTITLE,
  NO_RESULTS,
} from "./constants";
import { styles } from "./styles";
import {
  IDashboardPageExtraProps,
  IDirectorSportsState,
  IMenuAnchor,
  IProps,
} from "./types";
import { filterSportsBySeason } from "./utils";
import { AdvancedFilters } from "./components/advanced-filters/AdvancedFilters";
// import { ZENDESK_URL } from "src/constants";
import CustomModal from "src/components/CustomModal";
import { IUser } from "src/services";

const CustomSwitch = withStyles({
  switchBase: {
    color: "red", // Thumb color when off
    "&$checked": {
      color: "green", // Thumb color when on
    },
    "&$checked + $track": {
      backgroundColor: "green", // Track color when on
    },
    "& + $track": {
      backgroundColor: "red", // Track color when off
    },
  },
  checked: {},
  track: {},
})(Switch);

const getSeasonReportingPeriod = (
  selectedSeasonName: string | undefined,
  reportingYear: number
) => {
  const seasonName = (selectedSeasonName || "").toUpperCase();

  switch (seasonName) {
    case "FALL":
      return {
        display: `Fall: August 1, ${reportingYear - 1} - December 20, ${
          reportingYear - 1
        }`,
        startDate: new Date(reportingYear - 1, 7, 1, 0, 0, 0, 0),
        endDate: new Date(reportingYear - 1, 11, 20, 23, 59, 59, 999),
      };
    case "WINTER":
      return {
        display: `Winter: December 21, ${
          reportingYear - 1
        } - March 31, ${reportingYear}`,
        startDate: new Date(reportingYear - 1, 11, 21, 0, 0, 0, 0),
        endDate: new Date(reportingYear, 2, 31, 23, 59, 59, 999),
      };
    case "SPRING":
      return {
        display: `Spring: April 1, ${reportingYear} - July 31, ${reportingYear}`,
        startDate: new Date(reportingYear, 3, 1, 0, 0, 0, 0),
        endDate: new Date(reportingYear, 6, 31, 23, 59, 59, 999),
      };
    default:
      return {
        display: "",
        startDate: undefined,
        endDate: undefined,
      };
  }
};

const hasOpenSurveysInSeasonReportingPeriod = (
  surveys: ISurvey[],
  selectedSeasonName: string | undefined,
  reportingYear: number,
  selectedSeasonSportIds: number[]
) => {
  const { startDate, endDate } = getSeasonReportingPeriod(
    selectedSeasonName,
    reportingYear
  );

  if (startDate === undefined || endDate === undefined) {
    return false;
  }

  const startTime = startDate.getTime();
  const endTime = endDate.getTime();
  const currentTime = Date.now();

  return surveys.some((survey) => {
    const surveyStartTime = Number(survey.startDate);
    const isOpenSurvey =
      survey.responseCollectionEndDate === null &&
      !Number.isNaN(surveyStartTime) &&
      selectedSeasonSportIds.includes(survey.sportId) &&
      surveyStartTime <= currentTime &&
      surveyStartTime >= startTime &&
      surveyStartTime <= endTime;

    return isOpenSurvey;
  });
};

// const pathname = decodeURIComponent(window.location.pathname);
//   const pathSegments = pathname.split("/");
//   const lastSegment = pathSegments[pathSegments.length - 1];

//   const showReport = lastSegment !== "All Seasons";
  
export default withSchoolContext<IDashboardPageExtraProps>(
  withStyles(styles, { withTheme: true })(
    withAxios(
      class DashboardPageClass extends Component<IProps, IDirectorSportsState> {
        public static readonly EVALUATION_TIMEOUT = 10000000;

        public readonly state = this.buildState({
          editCoachModalVisible: false,
          openVarsityCoachModal: false,
          filter: "",
          menuAnchor: {
            id: "",
          },
          onlyShowInactive: false,
          search: "",
          sendEvalModalVisible: false,
          showInactive: false,
          showPrintButton: false,
          sport: "",
          showCoachModal: false,
          isMeadSeason: false,
          isJvCoach: false,
          forVideoMidSeson:false,
          particularCoachSportId: [],
          midSeasonCheckin: false,
          allEmail: [],
          surveysLoading: false, 
          surveysFetched: false,
          allSport: [],
          remainder:false,
          userData:"",
          showVideo: false, // State to control video visibility
          schoolData:"",
          reportGenerateModalVisible: false,
          reportData: [],
          showLoader: false,
          assignedSports2: [],
          getHeadCoachData: null,
          editCochaModalStatus:"",
          allowFullEditInCoachModal: false,
        });

        private handleSearchChange = this.stateInputEventHandler((v) => ({
          search: v,
        }));
        private printEvaluation?: PrintEvaluationFunc;
                         
        public componentDidMount = async () => {
          this.props.loadCoaches();
          const pathname = decodeURIComponent(window.location.pathname);
          const segments = pathname.split("/");

          // const lastSegment = segments[segments.length - 1];
          // const shouldShowReportButton = lastSegment !== "All Seasons";

          const totalLength = segments.length;
          const dashboardIndex = segments.indexOf("dashboard");
          const urlseason = segments[dashboardIndex + 1];
          const urlyear = segments[dashboardIndex + 2];
          if (totalLength === 6) {
            // alert("totalLength === 6")
       this.openReoprtModal(urlseason, urlyear)

          }
          const midSeasonCheckin: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${this.props.school.id}`)()
          console.log("midSeasonCheckin::::::::::::::::", midSeasonCheckin )
          this.setState({midSeasonCheckin: midSeasonCheckin?.data?.ismidseason, schoolData:
            midSeasonCheckin?.data
          })
          this.setState({ surveysLoading: true }); // Show loader when fetching starts

  try {
    await this.props.loadSurveys(); // Fetch the surveys
    this.setState({ surveysFetched: true }); // Mark that we got a response
  } finally {
    this.setState({ surveysLoading: false }); // Stop loader when done
  }
  this.props.loadUserSubscription()
  const res: any = await this.buildGet<IUser>(this, "user")()
     // Check if it's the first visit and midSeasonCheckin is true

  const isFirstVisit = sessionStorage.getItem("isFirstVisit") === "true";
  if (isFirstVisit && midSeasonCheckin) {
    // Show the video
    this.setState({ showVideo: true });
   // Remove the key after showing the video
    sessionStorage.removeItem("isFirstVisit");
  }
  const remainderData: any = await this.buildGet<IUser>(this, `/school/optlist/${res?.id}`)()
  console.log("remainderData::::::::::::::::", remainderData )
  const matchedItem = remainderData?.data.find(
    (item:any) => this.props.school.id === item.schoolId
  );
  const statusofremainder = matchedItem?.status;
  this.setState({ remainder: statusofremainder, userData: res });

  const hhheadcoch =  await this.buildPost<{userId:any, schoolId:any}, any>(
    this,"/coaches/getHeadCoach")({
    userId: res?.id,
    schoolId: this.props.school.id,

  });
  console.log("meadseson res:::", hhheadcoch, hhheadcoch)
  this.setState({getHeadCoachData: hhheadcoch?.data})
  if (hhheadcoch?.data?.type === "head" && hhheadcoch?.data !== null){
    this.setState({forVideoMidSeson: true})
    this.setState({ isMeadSeason: true,
      particularCoachSportId: hhheadcoch?.data?.sportId
    })
  }else if(hhheadcoch?.data?.type === "coach" && hhheadcoch?.data !== null){
    this.setState({isJvCoach: true})
  }
     const assignSport: any = await this.buildGet<IUser>(this, `/coaches/getAllHeadCoach/${this.props.school.id}`)()
                    console.log("res=========assignSport", assignSport)
                    this.setState({ assignedSports2: assignSport?.data })
  const AllAdEmail: any = await this.buildGet<IUser>(this, `/school/directorlistADVaild/${this.props.school.id}/${res?.id}`)()
  const arr: any[] = [];

  AllAdEmail?.forEach((item: any) => {
    arr.push(item?.email);
  })
  this.setState({allEmail: arr})
  this.setState({allSport: AllAdEmail})
 
  // Accept invitation if token and email are in localStorage to mark user's status as accepted
  const token = localStorage.getItem("invitationToken");
  const email = localStorage.getItem("invitationEmail");
  if (token && email) {
    try {
      await this.buildPost(this, "/accept-invitation")({ token, email });
      console.log("Invitation accepted successfully on dashboard");
      // Remove from localStorage after successful call
      localStorage.removeItem("invitationToken");
      localStorage.removeItem("invitationEmail");
    } catch (err: any) {
      console.error("Error accepting invitation:", err);
    }
  }
};
public GetAllReoprt = async (urlseason?: string, urlyear?: string) => {
     const {school } = this.props;
  try {
      // Example API call (replace with your actual API and params)
      const ReportData = await this.buildPost<{sportId: any, coachId: any, schoolId: any, type:any, year: any, sessionType: any}, any>(
        this, "/reports/reportGetAll"
      )({
        schoolId: school.id,
        sportId: -1,
        coachId: -1,
        type: "ad",
        // season: urlseason,
        year: urlyear,
        // "year":"2023",
        sessionType: urlseason ,
      });
      console.log("ReportData", ReportData, JSON.parse(ReportData?.data[1]?.chatgptChangeResposne || '{}')
);
this.setState({ reportData: ReportData?.data, schoolData: ReportData?.school
});

 // Build payload object
 const payload = {
  schoolId: school.id,
  sportId: -1,
  coachId: -1,
  type: "ad",
  year: urlyear ? urlyear : "2023",
  sessionType: urlseason ? urlseason : "FALL",
};

// Just console.log the payload instead of hitting API
console.log("Payload to be sent:", payload);


    } catch (error) {
      console.error("Error in ReportData", error);
    }   
 }
      public openReoprtModal = async (urlseason?: string, urlyear?: string) => {
        this.setState({ showLoader: true });
        await this.GetAllReoprt(urlseason, urlyear);
        this.setState({ showLoader: false });
  this.setState({ reportGenerateModalVisible: true });
};

  public closeReoprtModal = () =>
          this.setState({ reportGenerateModalVisible: false });

        public componentDidUpdate(prevProps: IProps, prevState: IDirectorSportsState) {
          const { seasonName, loadSurveys } = this.props;
          if (prevProps.seasonName !== seasonName) {
            loadSurveys();
            this.setState({
              filter: "",
            });
          }
          if (prevState.showLoader !== this.state.showLoader) {
            if (this.state.showLoader) {
              document.body.style.overflow = "hidden";
              document.documentElement.style.overflow = "hidden";
            } else {
              document.body.style.overflow = "";
              document.documentElement.style.overflow = "";
            }
          }
        }

        public componentWillUnmount() {
          if (this.state.showLoader) {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
          }
        }

        public async ToggleSchol(newStatus: boolean) {
          this.setState({ remainder: newStatus });
          const resuser: any = await this.buildGet<IUser>(this, "user")();
          
          try {
            const res: any = await this.buildPut(this, `/school/optout`)({
              status: newStatus,
              userId: resuser?.id,
              schoolId: this.props.school.id,
            });
        
            if (!res.status) {
              throw new Error("Status update failed");
            }else{
              alert("Status updated sucessfully")
        
              // ✅ Update local state immediately after successful backend response
              // this.setState({ remainder: newStatus });
            }
        
          } catch (error) {
            console.error("Error updating status:", error);
            this.setState({ remainder: !newStatus });
            alert("Failed to update status");
          }
        }
        
        public closeVideo = () => {
          this.setState({ showVideo: false });
        };
        
        public replayVideo = () => {
          this.setState({ showVideo: true });
        };
        


        public render() {
          const {
            filter,
            search,
            editCoachModalVisible,
            sendEvalModalVisible,
            coach,
            surveyResponse,
            startEvaluationSubmitting,
            printLoading,
            showInactive,
            onlyShowInactive, surveysFetched, surveysLoading,
            isMeadSeason, particularCoachSportId, isJvCoach, midSeasonCheckin,
            showVideo,schoolData, reportGenerateModalVisible, reportData, getHeadCoachData
          } = this.state;
          const { coaches, school, seasons, sports, seasonName, surveys } = this.props;
          console.log("school======?",school, surveys)
          console.log("Ad specific school dta=====", schoolData)
          const shouldShowLoader = surveysLoading && !surveysFetched;

          const pathname = decodeURIComponent(window.location.pathname);
          const segments = pathname.split("/");

          // const lastSegment = segments[segments.length - 1];
          // const shouldShowReportButton = lastSegment !== "All Seasons";

          // const totalLength = segments.length;
          const dashboardIndex = segments.indexOf("dashboard");
          const NormalUrlSeason = segments[dashboardIndex + 1];
          const currentReportingYear = new Date().getFullYear();
          const seasonReportingPeriod = getSeasonReportingPeriod(
            NormalUrlSeason,
            currentReportingYear
          );
          const selectedSeason = seasons.find(
            (season) =>
              season.name.toUpperCase() === NormalUrlSeason?.toUpperCase()
          );
          const hasOpenSurveysForSelectedSeason = hasOpenSurveysInSeasonReportingPeriod(
            surveys,
            NormalUrlSeason,
            currentReportingYear,
            selectedSeason?.sportIds || []
          );
          // const year = segments[dashboardIndex + 2];
      //     if (totalLength === 6) {
      //  this.openReoprtModal()

      //     }

          return (
            <Page
              header={school.name}
              // title={`Go ${school?.mascot?.trim() || school?.tagline?.trim() || ''}!`}
              title = {`Go ${
  school?.mascot?.trim() || 
  (school?.tagline?.trim()?.toLowerCase().startsWith("go") && 
    !/^[a-zA-Z]+$/.test(school?.tagline?.trim().split(' ')[0].substring(2))
    ? school?.tagline?.trim().substring(2).trim() 
    : school?.tagline?.trim()) || 
  ""
}!`}
              subtitle={DASHBOARD_SUBTITLE}
            >
              <EvaluationPrinter printEvaluationRef={this.setPrintEvaluation} />
                              <GenerateReportModal
                              ReportData={reportData}
                              schoolData={this.state.schoolData}
                                schoolId={school.id}
                                slug={school.slug}
                                open={reportGenerateModalVisible}
                                closeModal={this.closeReoprtModal}
                                refreshReports={() => this.GetAllReoprt(NormalUrlSeason, new Date().getFullYear().toString())} 
                                hasOpenSurveysInSeason={hasOpenSurveysForSelectedSeason}
                                seasonReportDateRange={seasonReportingPeriod.display}
                              />

                  {this.state.showLoader ? (
                    // ==================================
                    <div
                                    style={{
                                      position: "absolute", // absolute to modal
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      background: "rgba(0,0,0,0.3)",
                                      zIndex: 9999,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "column"
                                    }}
                                  >
                                    <CircularProgress size={60} style={{ color: "#1976d2" }} />
                                    <div style={{ color: "#fff", fontSize: 22, marginTop: 24, textAlign: "center" }}>
                                      Fetching report details... Do Not Refresh Your Screen.
                                      {/* Summary generation in progress, Do not refresh your screen. Please wait... */}
                                    </div>
                  {/* <div style={{ marginTop: 24 }}>
                    <CircularProgress />
                  </div> */}
                                  </div>
                  ) : null
                  }
                  
              {printLoading ? (
                <CircularProgress
                  style={{
                    left: "calc(50vw - ( 500px / 2))",
                    position: "fixed",
                    top: "calc(50vh - ( 500px /2))",
                  }}
                  size={500}
                />
              ) : null}
              {shouldShowLoader && midSeasonCheckin && (
                <LinearProgress
                  style={{
                    // position: "fixed",
                    // top: 0,
                    // left: 0,
                    width: "100%",
                  }}
                />
              )}
              {midSeasonCheckin && (
  <>
    {showVideo && (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        zIndex={1000}
        bgcolor="rgba(0, 0, 0, 0.8)"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          position="relative"
          width="80%"
          maxWidth="800px"
          bgcolor="#000"
          borderRadius="8px"
          overflow="hidden"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="1rem"
            borderBottom="1px solid rgba(255, 255, 255, 0.2)"
          >
            <Typography variant="h6" style={{ color: "#fff" }}>
              How to Video
            </Typography>
            <IconButton
              onClick={this.closeVideo}
              style={{ color: "#fff", position: "absolute", right: "1rem" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="flex" justifyContent="center" padding="1rem">
            <iframe
              width="100%"
              height="400"
                           // src="https://www.youtube.com/embed/80_LW-5saJc?autoplay=1&cc_load_policy=1"
                                        // with subtitle but no auto playing
                    // src="https://www.youtube.com/embed/80_LW-5saJc?autoplay=1"
                    src="https://www.youtube.com/embed/80_LW-5saJc?autoplay=1&cc_load_policy=1&mute=0"   // getting subtilte and auplay both without mute this is good option
              title="How to Video"
              style={{ border: "none", borderRadius: "8px" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={true}
            />
          </Box>
        </Box>
      </Box>
    )}

   
              {/* Move the "How to Video" button above all seasons */}
    <Button
      onClick={this.replayVideo}
      variant="outlined"
      color="primary"
      style={{ marginBottom: "1rem" }}
    >
      How to Video
    </Button>
  </>
)}
              <SeasonTabs schoolSlug={school.slug} seasons={seasons} forVideoMidSeson={this.state.forVideoMidSeson}/>
              <Box alignItems="center" display="flex" gridGap="1rem">
                <AdvancedFilters
                 schoolData={this.state.schoolData}
                  filter={filter}
                  search={search}
                  seasons={seasons}
                  sports={sports}
                  seasonName={seasonName}
                  handleSearchChange={this.handleSearchChange}
                  handleFilterChange={this.handleFilterChange}
                  showInactive={showInactive}
                  onlyShowInactive={onlyShowInactive}
                  toggleShowInactive={this.toggleShowInactive}
                  toggleOnlyShowInactive={this.toggleOnlyShowInactive}
                  isMeadSeason= {isMeadSeason}
                  coachsportId= {particularCoachSportId}
                />
                {console.log(this.props, isJvCoach, "props testing 11")}
                {/* {isJvCoach !== true && schoolData&& */}
                { this.props?.school?.ismidseason === false && !this.props?.school?.isEmbeddable &&
                   <Box>
                  <div className="coach-add">
                    <Button
                     onClick={()=> {this.openEditCoachModal("NewCoach")}}
                      variant="outlined"
                      color="primary"

                    >
                    {schoolData?.isAdSurvey === true ? "Add AD Name": 
                    <>
                    {/* add new sub-varsity coach */}
                    {/* { this.props?.school?.ismidseason?"NEW SUB-VARSITY COACH" :CREATE_COACH_BUTTON_TEXT } */}
                    {(this.props?.school as { ismidseason?: boolean })?.ismidseason 
  ? "ADD SUB-VARSITY COACH" 
  : CREATE_COACH_BUTTON_TEXT}
                      </>
                    }
                    </Button>
                  </div>

                  

                </Box>
                }
                {/* getting both buttons for midseason checkin */}
                {midSeasonCheckin && getHeadCoachData === null && !this.props?.school?.isEmbeddable &&
                <>
                <Box>
                  <div className="coach-add">
                    <Button
                     onClick={()=> {this.openEditCoachModal("NewCoach")}}
                      variant="outlined"
                      color="primary"

                    >
                    {schoolData?.isAdSurvey === true ? "Add AD Name": 
                    <>
                    {/* add new sub-varsity coach */}
                    {/* { this.props?.school?.ismidseason?"NEW SUB-VARSITY COACH" :CREATE_COACH_BUTTON_TEXT } */}
                    {(this.props?.school as { ismidseason?: boolean })?.ismidseason 
  ? "ADD SUB-VARSITY COACH" 
  : CREATE_COACH_BUTTON_TEXT}
                      </>
                    }
                    </Button>
                  </div>

                  

                </Box>
                 
        {/* } */}

         
                <Box>
                  <div className="coach-add">
                    <Button
                    onClick={this.handleOpenVarsityCoachModal}
                      variant="outlined"
                      color="primary"

                    >
                    {schoolData?.isAdSurvey === true ? "Add AD Name": 
                    <>
                    {/* add new sub-varsity coach */}
                    {/* { this.props?.school?.ismidseason?"NEW SUB-VARSITY COACH" :CREATE_COACH_BUTTON_TEXT } */}
                    {/* {(this.props?.school as { ismidseason?: boolean })?.ismidseason 
                        ? "ADD SUB-VARSITY COACH" 
                        : CREATE_COACH_BUTTON_TEXT} */}
                        Add varsity head coach
                      </>
                    }
                    </Button>
                  </div>

                  

                </Box>
                </>
                 
        }

{/* getting Add sub varsity coach button for head coach only */}
        {midSeasonCheckin && getHeadCoachData?.type === "head" && !this.props?.school?.isEmbeddable &&
              
                <Box>
                  <div className="coach-add">
                    <Button
                      onClick={()=> {this.openEditCoachModal("NewCoach")}}
                      variant="outlined"
                      color="primary"

                    >
                    {schoolData?.isAdSurvey === true ? "Add AD Name": 
                    <>
                    {/* add new sub-varsity coach */}
                    {/* { this.props?.school?.ismidseason?"NEW SUB-VARSITY COACH" :CREATE_COACH_BUTTON_TEXT } */}
                    {(this.props?.school as { ismidseason?: boolean })?.ismidseason 
  ? "ADD SUB-VARSITY COACH" 
  : CREATE_COACH_BUTTON_TEXT}
                      </>
                    }
                    </Button>
                  </div>

                  

                </Box>
        }
    
        {
  !(this.props.school as { ismidseason?: boolean }).ismidseason && // ⬅ true if not midseason
  !(this.props.school as { isAdSurvey?: boolean }).isAdSurvey &&   // ⬅ true if not an Ad survey
  // shouldShowReportButton &&                                       // ⬅ true if report button should be shown
  ["FALL", "WINTER", "SPRING"].includes(NormalUrlSeason?.toUpperCase() || "") && // ⬅ Show Report button only for fall, winter, and spring
  (
    <Button
      // onClick={() => this.openReoprtModal(lastSegment, currentYear)}
      onClick={() => this.openReoprtModal(NormalUrlSeason, new Date().getFullYear().toString())}
      // onClick={() => this.openReoprtModal(NormalUrlSeason, "shubham")}


      className="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary"
    >
      View Seasonal Report
    </Button>
  )

}

       
        {this.state?.userData?.isAdmin === false &&
      <Tooltip
                            title={
                              <Typography style={{ fontSize: "16px", padding: "8px", display: "block", maxWidth: "300px" }}>
                              Toggle on to receive automatic email reminders to set up coaches, send midseason check-ins, and plan end-of-season meetings, at the right time!
                               {/* {school.status ? "Warning: Deactivating this school will hide it from all users and prevent access until reactivated.":
                               "Info: Activating this school will make it visible to all users and restore full access."
                            } */}
                              </Typography>
                            }
          placement="right"
          arrow={true}
        >
        
                            <FormControlLabel style={{marginTop:"7px", float:"right"}}
          control={
            <CustomSwitch
              checked={this.state.remainder === true}
              onChange={(e) => this.ToggleSchol(e.target.checked)}
              value="check"
            />
          }
          label=""
        />
        </Tooltip>
        }
              </Box>

              {this.renderTables()}

              <EditCoachModal
                changeEditCoach={this.changeEditCoach}
                coaches={coaches}
                editCochaModalStatus={this.state.editCochaModalStatus}
                allowFullEdit={this.state.allowFullEditInCoachModal}
                open={editCoachModalVisible}
                schoolData={this.state.schoolData}
                closeModal={this.closeEditCoachModal}
                coach={coach}
                midSeasonCheckin={midSeasonCheckin}
                Allmail = {this.state.allEmail}
                Allsport = {this.state.allSport}
                assignedSports = {this.state.assignedSports2}
                refreshCoaches={this.props.loadCoaches} 
              />
              <VarsityCoachModal
                 changeEditCoach={this.handleOpenVarsityCoachModal}
                coaches={coaches}
                open={this.state.openVarsityCoachModal}
                schoolData={this.state.schoolData}
                closeModal={this.closeEditVarsityCoachModal}
                coach={coach}
                midSeasonCheckin={midSeasonCheckin}
                Allmail = {this.state.allEmail}
                Allsport = {this.state.allSport}
                assignedSports = {this.state.assignedSports2}
                refreshCoaches={this.props.loadCoaches} 
              />
              <SendEvalModal
                open={sendEvalModalVisible}
                schoolData={this.state.schoolData}
                closeModal={this.handleSendEvalModalVisible}
                surveyResponse={surveyResponse}
                startEvaluationSubmitting={startEvaluationSubmitting}
                route={`/${this.props.school.slug}/upgrade-subscription`}
                // history={this.props.history}
              // userSubscription={this.props?.userSubscription}
              />
              <CustomModal open={this.state.showCoachModal} handleClose={() => { this.setState({ showCoachModal: false }) }} handleOk={() => {
                this.setState({ showCoachModal: false })
                if(this.props?.userSubscription?.plans?.id===1){
                  this.props.history.push(`/${school.slug}/upgrade-subscription`)
                }else{
                  this.props.history.push(`/${school.slug}/subscription-history`)
                }
             
              }}
                positiveText={"Upgrade"}
                title={"Add more coaches?"}
                description={"Would you like to upgrade your subscription to add more coaches?"}
              />
            </Page>
          );
        }

        private toggleShowInactive = () => {
          this.setState((oldState) => ({
            onlyShowInactive: false,
            showInactive: !oldState.showInactive,
          }));
        };

        private toggleOnlyShowInactive = () => {
          this.setState((oldState) => ({
            onlyShowInactive: !oldState.onlyShowInactive,
            showInactive: true,
          }));
        };

        private renderTables() {
          const {
            filter,
            search,
            menuAnchor,
            showInactive,
            showPrintButton,
            onlyShowInactive,
            midSeasonCheckin
          } = this.state;
          const {
            classes,
            seasons,
            seasonName,
            sports,
            surveys,
            coaches,
            loadSurveys,
            school,
          } = this.props;
          const filteredSports = filter
            ? sports.filter((sport) => sport.name === filter)
            : sports;
          const sportTables = filterSportsBySeason({
            seasonName,
            seasons,
            sports: filteredSports,
          });

          // Keep sports based on the selected active/inactive coach filters.
          const visibleSports = sportTables.filter((sport) => {
            const sportCoaches = coaches.filter((coach) =>
              coach.sports.some((coachSport) => coachSport.id === sport.id)
            );

            if (sportCoaches.length === 0) {
              return false;
            }

            if (onlyShowInactive) {
              return sportCoaches.some((coach) => !coach.active);
            }

            if (showInactive) {
              return true;
            }

            return sportCoaches.some((coach) => coach.active);
          });

          if (visibleSports.length <= 0) {
            return (
              <Box marginTop="2rem">
                <Typography variant="h5">
                  {this.state.schoolData?.isAdSurvey
                    ? "No AD selected"
                    : NO_RESULTS}
                </Typography>
              </Box>
            );
          }

          const embedCoaches = coaches.filter(
            (coach) => coach.extra_emails && coach.extra_emails.length > 0
          );

          return (
            <Box className={classes.sportTablesWrapper} marginTop="1.5rem">
              {console.log("sportTables", visibleSports, coaches, surveys)}
              {!school.isEmbeddable  && visibleSports.map((sport) => (
                <SportTable
                  key={sport.id}
                  search={search}
                  sport={sport}
                  coaches={coaches}
                  surveys={surveys.filter(
                    (survey) => survey.sportId === sport.id
                  )}
                  schoolData={this.state.schoolData}
                  school={school}
                  loadSurveys={loadSurveys}
                  menuAnchor={menuAnchor}
                  setMenuAnchor={this.setMenuAnchor}
                  handleSendEvalModalVisible={this.handleSendEvalModalVisible}
                  handlePrintPress={this.handlePrintPress}
                  showPrintButton={showPrintButton}
                  openEditCoach={this.openEditCoach}
                  schoolSlug={school.slug}
                  showInactive={showInactive}
                  onlyShowInactive={onlyShowInactive}
                  userSubscription={this.props?.userSubscription}
                  midSeasonCheckin={midSeasonCheckin}
                />
              ))}

              {school.isEmbeddable && embedCoaches.length > 0 && (
                <EmbedCoachTable
                  coaches={embedCoaches}
                  school={school}
                />
              )}
            </Box>
          );
        }

        private handleFilterChange = (
          e: React.ChangeEvent<HTMLSelectElement>
        ) => this.setState({ filter: e.target.value });

        // change coach before opening Modal
        private openEditCoach = async (
          coach: ICoach,
          allowFullEditInCoachModal = false
        ) => {
          this.setState({ coach, allowFullEditInCoachModal },()=>{
            this.openEditCoachModal();
          });
    
        };

        private readonly setPrintEvaluation = (
          printEvaluation: PrintEvaluationFunc | null
        ) => {
          this.printEvaluation = printEvaluation ?? undefined;
          this.setState({
            showPrintButton: !!this.printEvaluation,
          });
        };

        private openEditCoachModal = (status?: string) => {
          const {midSeasonCheckin, schoolData } =  this.state;
          if (midSeasonCheckin){
            this.setState({ editCoachModalVisible: true, editCochaModalStatus: status  });
          }else{
            if(this.state.coach){
              this.setState({ editCoachModalVisible: true });
              
            }else{
              if (Object.keys(this.props?.userSubscription).length > 0) {

                if (this.props?.userSubscription?.plans?.id < 5) {
                  // console.log("this.props?.coaches?.length", this.props?.coaches?.length, Number(this.props.userSubscription?.plans?.coachs))
                  if (Number(this.props.userSubscription?.plans?.coachs) > this.props?.coaches?.length) {
                    this.setState({ editCoachModalVisible: true });
                  } else {
                    //  check
                    if (schoolData?.isAdSurvey === true) {
                      this.setState({ editCoachModalVisible: true });
                    } else {
                      this.setState({ showCoachModal: true });
                  // alert("Please upgrade subscription if you want to add more coaches")
                  // this.props.history.push(`/${this.props.school.slug}/plan-details`)
                  // window.open(ZENDESK_URL, "_blank");
                    }
                  }
                } else {
                  this.setState({ editCoachModalVisible: true });
                }
              } else {
                this.setState({ editCoachModalVisible: true });
              }
            }

          }

        }

        private changeEditCoach = (coach: ICoach) => {
          this.closeEditCoachModal();
          this.openEditCoach(coach);
          this.props?.loadUserSubscription()
        };

        private setMenuAnchor = (menuAnchor: IMenuAnchor) =>
          this.setState({
            menuAnchor,
          });

        private closeEditCoachModal = () =>
          this.setState({
            coach: undefined,
            editCoachModalVisible: false,
            allowFullEditInCoachModal: false,
          });

           private closeEditVarsityCoachModal = () =>
          this.setState({ coach: undefined, openVarsityCoachModal: false });

private handleOpenVarsityCoachModal = () =>
  this.setState({ coach: undefined, openVarsityCoachModal: true });

        private handleSendEvalModalVisible = (
          surveyResponse?: ISurveyResponse
        ) => {
          this.setState((prevState) => {
            return {
              sendEvalModalVisible: !prevState.sendEvalModalVisible,
              surveyResponse,
            };
          });
        };

        private handlePrintPress = (
          coach: ICoach,
          sport: ISport,
          survey: ISurvey
        ): void =>
          void this.runCancellableStatefulAsync(
            this,
            {
              printLoading: true,
            },
            {
              printLoading: undefined,
            },
            async () => {
              if (this.printEvaluation === undefined) {
                return;
              }
              const { school } = this.props;
              await this.printEvaluation(school, survey.id, coach.id);
            },
            () => {
              // Do nothing
              this.setState({
                printLoading: undefined,
              });
            }
          );
      }
    )
  )
);






// WEBPACK FOOTER //
// ./src/pages/director/dashboard/Dashboard.tsx